<template>
  <div class="hero-alider-area">
    <div class="hero-slider__container-area">
      <div class="swiper-container hero-slider__container">
        <div class="swiper-wrapper hero-slider__wrapper">
          <swiper :options="swiperOption">
            <!--=======  single slider item  =======-->

            <div
              class="swiper-slide hero-slider__single-item"
              :style="{
                backgroundImage: 'url(' + $backendPublic + item.image + ')',
              }"
              v-for="item in sliderData"
              :key="item.id"
            >
              <div class="hero-slider__content-wrapper">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="hero-slider__content ">
                        <h2 class="hero-slider__title">{{ item.title }}</h2>
                        <p class="hero-slider__text" v-html="item.desc"></p>
                        <a
                          v-if="item.link"
                          :href="item.link"
                          class="hero-slider__btn"
                          >جزییات بیشتر</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--=======  End of single slider item  =======-->
            <div
              class="ht-swiper-button-prev ht-swiper-button-prev-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-forward"></i>
            </div>
            <div
              class="ht-swiper-button-next ht-swiper-button-next-13 ht-swiper-button-nav d-none d-xl-block"
            >
              <i class="ion-ios-arrow-left"></i>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { slideShowStore } from "@/store/Modules/slideShow.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  props: ["sliderData"],
  data() {
    return {
      swiperOption: {
        speed: 1500,
        loop: true,
        effect: "fade",
        autoplay: false,
        spaceBetween: 30,
        navigation: {
          nextEl: ".ht-swiper-button-next",
          prevEl: ".ht-swiper-button-prev",
        },
      },
    }
  },
  mounted() {
    this.getSlideShowsAction()
  },
  computed: {
    ...mapState(slideShowStore, ["getSlideShows"]),
  },
  methods: { ...mapActions(slideShowStore, ["getSlideShowsAction"]) },
}
</script>

<style lang="scss"></style>
